import { storeToRefs } from 'pinia';
import CreditData from '~/app/auth/classes/CreditData';
import { ModelType } from '~/app/base/schemas/BaseSchema';
import EndpointFactory from '~/app/factories/EndpointFactory';

const creditData = ref<CreditData>();

export default function useCreditData() {
    const endpoint = EndpointFactory.make(ModelType.TENANTS);
    const { tenant } = storeToRefs(useAuthStore());

    const getCreditData = async () => {
        if (!tenant.value?.getId()) {
            return;
        }

        try {
            const response = await endpoint.credits(tenant.value.getId());
            creditData.value = response;
        } catch (error) {
            useToasteoError('Failed to fetch credit data.');
        }
    };
    return { creditData, getCreditData };
}
